import React from "react";
import { Container, Row, Col, Card, CardBody, Media } from "reactstrap";
import { notifyError } from "../../utils/utils";
import { getDashboardData } from "../../services/userService";

class Dashboard extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            countData: {}
        };
    }

    componentDidMount() {

        getDashboardData()
            .then(res => {
                const { data } = res;
                if (data.status) {
                    this.setState({
                        countData: data.countData
                    });
                } else {
                    notifyError(data.message);
                }
            })
    }

    render() {
        const { countData } = this.state;

        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                      
                        <Card className="p-2">
                            <h3 className="p-3"> Dashboard</h3>
                            <hr/>
                            <Row className="p-2">
                                <Col key={"sale"} lg={3} md={6} sm={12} xs={12}>
                                    <Card outline color="primary" className="border">
                                        <CardBody>
                                            <Media>
                                                <Media body className="overflow-hidden">
                                                    <p className="text-truncate font-size-14 mb-2">Users</p>
                                                    <h4 className="mb-0"> {countData ? countData.users : 0}</h4>
                                                </Media>
                                                <div className="text-primary">
                                                    <i className={"fas fa-user font-size-24"}></i>
                                                </div>
                                            </Media>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        </Card>
                    </Container>
                </div>
            </React.Fragment>
        )
    }
}

export default Dashboard;